interface Props {
  open: boolean;
  onClose: () => void;
}

const SECTIONS: Array<{ title: string; rows: Array<[string, string]> }> = [
  {
    title: 'Tools',
    rows: [
      ['V', 'Selection'],
      ['H', 'Hand (pan)'],
      ['R', 'Rectangle'],
      ['D', 'Diamond'],
      ['O', 'Ellipse'],
      ['A', 'Arrow'],
      ['L', 'Line'],
      ['P', 'Pen (freehand)'],
      ['T', 'Text'],
      ['S', 'Sticky note'],
      ['F', 'Frame'],
      ['E', 'Eraser'],
    ],
  },
  {
    title: 'Edit',
    rows: [
      ['Ctrl/⌘ + Z', 'Undo'],
      ['Ctrl/⌘ + Shift + Z', 'Redo'],
      ['Ctrl/⌘ + A', 'Select all'],
      ['Ctrl/⌘ + C', 'Copy'],
      ['Ctrl/⌘ + X', 'Cut'],
      ['Ctrl/⌘ + V', 'Paste'],
      ['Ctrl/⌘ + D', 'Duplicate'],
      ['Delete / Backspace', 'Delete selection'],
      ['Escape', 'Deselect / cancel'],
      ['Double-click text', 'Edit text'],
    ],
  },
  {
    title: 'View',
    rows: [
      ['Ctrl/⌘ + scroll', 'Zoom to cursor'],
      ['Space / Alt + drag', 'Pan'],
      ['Middle click drag', 'Pan'],
      ['Ctrl/⌘ + 0', 'Reset view'],
    ],
  },
  {
    title: 'Layer',
    rows: [
      ['Ctrl/⌘ + ]', 'Bring forward'],
      ['Ctrl/⌘ + [', 'Send backward'],
      ['Ctrl/⌘ + Shift + ]', 'Bring to front'],
      ['Ctrl/⌘ + Shift + [', 'Send to back'],
    ],
  },
];

export const HelpPanel = ({ open, onClose }: Props) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40" onClick={onClose}>
      <div
        className="w-[560px] max-w-[92vw] max-h-[80vh] overflow-y-auto rounded-xl bg-white dark:bg-neutral-900 shadow-2xl ring-1 ring-black/10 p-5 flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-base font-semibold text-neutral-800 dark:text-neutral-100">Keyboard shortcuts</h2>
          <button className="text-neutral-500 text-lg" onClick={onClose}>×</button>
        </div>
        {SECTIONS.map((sec) => (
          <div key={sec.title}>
            <h3 className="text-xs uppercase tracking-wide text-neutral-500 dark:text-neutral-400 mb-2">{sec.title}</h3>
            <div className="grid grid-cols-2 gap-y-1 gap-x-4">
              {sec.rows.map(([k, v]) => (
                <div key={k} className="flex items-center gap-2 text-xs">
                  <kbd className="px-1.5 py-0.5 rounded bg-neutral-100 dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-700 font-mono">
                    {k}
                  </kbd>
                  <span className="text-neutral-600 dark:text-neutral-300">{v}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
